/**
 * @description Функция вычисляет первоначальную ширину, которую занимает строка БЕЗ тегов.
 * Учитывает кастомный контент ДО и ПОСЛЕ группы тегов ("leftAdornment", "rightAdornment"),
 * а также ширину контрола "Показать ещё"/"Скрыть".
 */
export function getInitialCurrentRowWidth(currentRowWidth, cloudControlButtonWidth, leftAdornmentWidth, rightAdornmentWidth, currentRowIndex, maxLines) {
  // Это означает, что в строка уже получила какую-то ширину, ничего добавлять не требуется
  if (currentRowWidth !== 0) {
    return currentRowWidth;
  }
  const isSingleRowMode = maxLines === 1;
  const isFirstRow = currentRowIndex === 1;
  const isLastRow = currentRowIndex === maxLines;

  // Если строка всего одна, то учитываем все элементы, которые могут в ней быть
  if (isSingleRowMode) {
    return cloudControlButtonWidth + leftAdornmentWidth + rightAdornmentWidth;
  }

  // Если строка первая, то учитываем только кастомный контент слева (ДО тегов)
  if (isFirstRow) {
    return leftAdornmentWidth;
  }

  // Если строка последняя, то учитываем только кастомный контент справа (ПОСЛЕ тегов) и кнопку "Показать ещё"/"Скрыть"
  if (isLastRow) {
    return cloudControlButtonWidth + rightAdornmentWidth;
  }

  // Это значит, что текущая строка где-то между первой и последней, поэтому её первоначальная ширина равна нулю
  return 0;
}